(function () {
    'use strict';

    angular.module('thankview.global')
        .directive('fitText', ['$window', '$document', '$timeout', function ($window, $document, $timeout) {
            return {
                restrict: 'A',
                scope: {
                    project: '=?',
                    maxFont: '@',
                    baseWidth: '@',
                },
                link: function (scope, element) {
                    let calcFontSizeTimer;
                    let resizeTimer;

                    // if project wasn't passed, the backend probably passed it as a js param
                    if (!scope.project && config.params.project) {
                        scope.project = config.params.project;
                        scope.project.font = config.params.font;
                    }
                    // if the project is still not defined, log error in Bugsnag then bail
                    if (!scope.project) {
                        console.error('Fit text directive is missing project');
                        if ($window.Bugsnag) {
                            Bugsnag.notify(new Error('Fit-Text Directive Missing Project'), (event) => {
                                event.addMetadata('custom', { width: scope.baseWidth, font: scope.maxFont, el: element[0] });
                            });
                        }
                        return;
                    }

                    // event handlers for recalculating font size
                    angular.element($window).on('resize', () => {
                        $timeout.cancel(resizeTimer);
                        resizeTimer = $timeout(scope.calcFontSize, 100);
                    });

                    scope.$on('calculate-fit-text-size', () => {
                        scope.calcFontSize();
                    });

                    /**
                     * helper function for determining if a message will fit in this element at the provided font size
                     * @param message: the text we'd like to try to fit
                     * @param currentFontSize: the font size to start with
                     * @return: the font size that allows the provided message to fit
                     */
                    function calcFit(message, currentFontSize) {
                        const canvas = angular.element('<canvas></canvas>')[0];
                        const ctx = canvas.getContext('2d');
                        const font = scope.project.font.name;
                        let fontSize = currentFontSize;
                        ctx.font = fontSize + 'px ' + font;
                        let textWidth = ctx.measureText(message).width;
                        // as long as the text width is greater than the element width
                        while (textWidth > element[0].clientWidth) {
                            fontSize -= 1; // reduce font size by 1px
                            ctx.font = fontSize + 'px ' + font;
                            textWidth = ctx.measureText(message).width;
                        }
                        return fontSize;
                    }

                    scope.calcFontSize = () => {
                        $timeout.cancel(calcFontSizeTimer);

                        // recursively call the function if the
                        // element hasn't rendered yet
                        if (element[0].clientWidth === 0) {
                            calcFontSizeTimer = $timeout(scope.calcFontSize, 100);
                            return;
                        }

                        // we need to know the current width of our text element, compared to is maximum "base" width
                        // this will serve as our maximum font ratio
                        const sizeRatio = Math.min(element[0].clientWidth / parseInt(scope.baseWidth, 10), 1); // don't go over max
                        let finalFontSize = parseInt(scope.maxFont, 10) * sizeRatio;
                        let marginSubtract = 0; // we want to reduce top margin on the text slightly if there are multiple lines

                        // reset inline margin top value
                        element[0].style.marginTop = '';

                        // if text before the name is on its own line
                        // calculate if that message will currently fit
                        if (scope.project.naming_text_before_own_line && scope.project.naming_text_before) {
                            const fSize = calcFit(scope.project.naming_text_before, finalFontSize);
                            marginSubtract += 10 * sizeRatio;
                            // if the size we just calculated is smaller than our existing final font size, save it
                            if (fSize < finalFontSize) {
                                finalFontSize = fSize;
                            }
                        }
                        // repeat for after text
                        if (scope.project.naming_text_after_own_line && scope.project.naming_text_after) {
                            const fSize = calcFit(scope.project.naming_text_after, finalFontSize);
                            marginSubtract += 10 * sizeRatio;
                            // if the size we just calculated is smaller than our existing final font size, save it
                            if (fSize < finalFontSize) {
                                finalFontSize = fSize;
                            }
                        }
                        element[0].style.marginTop = (parseInt($window.getComputedStyle(element[0]).getPropertyValue('margin-top'), 10) - marginSubtract) + 'px';
                        element[0].style.fontSize = finalFontSize + 'px';
                        element[0].style.opacity = 1; // sometimes we hide the text before fitting it, ensure opacity is set to 1
                    };

                    // we have to set a timeout on this to better ensure layout work has completed
                    // before we try to calculate the font size
                    scope.calcFontSize();
                },
            };
        }]);
}());
